import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgxCsvParserModule } from 'ngx-csv-parser';

@NgModule({ imports: [NgxCsvParserModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class CoreModule {}
